module.exports = __webpack_public_path__ + "static/torchbefore-092df996cca2942230659b0feeda0985.jpg";